import { useEffect, useMemo, useState } from 'react'

import {
  getLocationAddress,
  selectAllServiceLocations,
} from '@user/store/entityLocations'
import { NoteCode } from '@user/components/Notes/typings'
import { getNoteCodes } from '@user/store/notes/api'
import { useAppDispatch } from '@user/store/hooks'
import { useSelector } from 'react-redux'

export function usePestPacNoteOptionsSelector() {
  const serviceLocations = useSelector(selectAllServiceLocations)

  const serviceOptions = useMemo(
    () =>
      serviceLocations.map((l) => ({
        value: l.id.toString(),
        label: `${l.locationCode} - ${getLocationAddress(l)}`,
      })) || [],
    [serviceLocations],
  )
  const [noteCodes, setNoteCodes] = useState<NoteCode[]>([])

  const dispatch = useAppDispatch()

  useEffect(() => {
    const getAllNoteCodes = async () => {
      try {
        const result = await dispatch(getNoteCodes())
        if (getNoteCodes.fulfilled.match(result)) {
          const { payload } = result
          setNoteCodes(payload?.items || [])
        }
      } catch (error) {
        setNoteCodes([])
      }
    }

    getAllNoteCodes()
  }, [dispatch])

  return {
    serviceLocations,
    serviceOptions,
    noteCodes,
  }
}
